import { createContext, useContext } from "react";
import { STRINGS_ENV } from "../config/stringsEnv";

const EnvContext = createContext(STRINGS_ENV);

export const EnvProvider = ({ children }) => {
  return (
    <EnvContext.Provider value={STRINGS_ENV}>
      {children}
    </EnvContext.Provider>
  );
};

export const useEnv = () => useContext(EnvContext);
